import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import Button from 'web/components/Button';
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { paymentClientSecret, verifyApi } from 'redux/actions/payment';
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './popup.scss';

export default ({ isOpen, toggle, individual, callBackModal, accountResponse, callBackFetchApi, content, link, onClickHander, selectedAchAccountForVerify }) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState();
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  useEffect(() => {
    paymentClientSecretApi()
  }, []);


  const redirectLink = (link) => {
    toggle(!isOpen)
  }
  const callBackFun = () => {
    toggle(!isOpen)
  }

  const getRegisterInitialValues = (obj) => {
    return {
      deposit1: '',
      deposit2: '',
      descriptorCode: ''
    }
  }
  const VALIDATION_SCHEMA = Yup.object().shape({
  });

  const [getClientSecret, setClientSecret] = useState(false);
  const paymentClientSecretApi = async () => {
    let response = await dispatch(paymentClientSecret(token));
    setClientSecret(response)
  }
  const submitHandler = async (props) => {
    let data = {}
    let responseClientKey = selectedAchAccountForVerify ? selectedAchAccountForVerify.clientSecret : ''
    if (props.values.descriptorCode !== '') {
      data = {
        descriptor_code: props.values.descriptorCode
      }
    } else if (props.values.deposit1 !== '' && props.values.deposit2 !== '') {
      data = {
        amounts: [props.values.deposit1, props.values.deposit2],
      }
    }
    let result = stripe.verifyMicrodepositsForSetup(responseClientKey, data).then(res => {
      verify(res)
    }).catch(err => {
    })
  };

  const verify = async (result) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let data
      if (result.setupIntent) {
        if (result.setupIntent.status === "succeeded") {
          data = {
            paymentMethodId: selectedAchAccountForVerify.id,
            isVerified: true
          }
        } else {
          data = {
            paymentMethodId: selectedAchAccountForVerify.id,
            isVerified: false
          }
        }
      } else {
        data = {
          paymentMethodId: selectedAchAccountForVerify.id,
          isVerified: false
        }
      }
      let response = await dispatch(verifyApi(data, token));
      if (response.status === 'SUCCESS') {
        setAlertType('achVerficationModal')
        if (data.isVerified) {
          setModalContent('Your account has been verified successfully.');
          setModalLink('');
          toggleModal();
        } else {
          setModalContent('Account verification failed.Please verify again.');
          setModalLink('');
          toggleModal();
        }
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setAlertType('achVerficationModal')
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              onClickHander('close')
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" onClick={toggle} />
            </Button>
            <h3>Verify Deposit Amount</h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content'>
              <Formik
                validateOnMount
                enableReinitialize={true}
                initialValues={getRegisterInitialValues()}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const { values, setFieldValue, setTouched, validateForm, isValid, dirty } = props;
                  return (
                    <Form className="form">
                      <div><div class="app-input-text"></div></div>
                      <div><p>Deposit 1<span class="star">*</span></p>
                        <div>
                          <NumberInput
                            name='deposit1'
                            placeholder='Deposit Amount'
                            maxLength='20'
                          />
                        </div>
                      </div>
                      <div><p>Deposit 2<span class="star">*</span></p>
                        <div>
                          <NumberInput
                            name='deposit2'
                            placeholder='Deposit Amount'
                            maxLength='20'
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold' }}><p>[Or]</p></div>
                      <div><p>Descriptor Code<span class="star">*</span></p>
                        <div>
                          <TextInput
                            name='descriptorCode'
                            placeholder='Descriptor Code'
                            maxLength='20'
                          />
                        </div>
                      </div>

                      <Button
                        type='app-green-button'
                        disabled={!((props.values.deposit1 !== '' && props.values.deposit2 !== '') || (props.values.descriptorCode !== ''))}
                        // disabled={!(props.values.descriptorCode !== '')}
                        handleClick={() => {
                          submitHandler(props);
                        }}
                      >
                        Submit
                      </Button>

                    </Form>
                  );
                }}
              </Formik>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'achVerficationModal') {
            callBackModal()
          }
        }}
      />
    </div>
  );
};
